import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

const Bell = ({ new_notify, setReadNotification, menuActive }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (new_notify) {
      setReadNotification();
    }
    navigate("/notification");
  };

  const iconClass = `
    w-[16px] h-[18px] p-1 rounded-full
    lg:w-[28px] lg:h-[28px]
    ${
      menuActive === "/notification"
        ? "text-blue-500 bg-[#cae1ff8c]"
        : "text-black"
    }
  `;

  return (
    <button
      onClick={handleClick}
      className="relative flex items-center mr-5 outline-none cursor-pointer"
    >
      <FontAwesomeIcon icon={faBell} className={iconClass} />

      {new_notify && (
        <div className="absolute -top-2 -right-2 w-4 h-4 bg-[#ff4545] border-2 border-white rounded-full hover:scale-110 transition-all duration-300" />
      )}
    </button>
  );
};

export default Bell;